import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useQuery } from 'src/core/utils/formater';
import newAlert from 'src/components/newAlert';
import { Button } from 'antd';
import CanView from 'src/components/permission/canview';
import { FileUpload } from './fileUpload';
import { TokenView } from './tokenView';
import { start_loading, end_loading } from '../../../core/actions/loader';
import { set_notification_type } from '../../../core/actions/notificationType';

const stateList = {
  error: 'Aмжилтгүй',
  started: 'Эxэлсэн',
  complete: 'Амжилттай',
};

const typeList = {
  1: 'Диамонд',
  2: 'Смарт ложик',
  3: 'Эрхэт',
  4: 'Такс',
  5: 'Даянсофт',
};

// Shared styles
const thStyle = {
  padding: '12px 16px',
  textAlign: 'left',
  fontSize: '12px',
  fontWeight: '500',
  color: '#6b7280',
  textTransform: 'uppercase',
};

const tdStyle = {
  padding: '12px 16px',
  whiteSpace: 'nowrap',
  fontSize: '14px',
  color: '#111827',
};

const getStatusStyle = (state) => {
  switch (state) {
    case 'complete':
      return {
        backgroundColor: '#dcfce7',
        color: '#166534',
      };
    case 'error':
      return {
        backgroundColor: '#fee2e2',
        color: '#991b1b',
      };
    default:
      return {
        backgroundColor: '#fef9c3',
        color: '#854d0e',
      };
  }
};

const Noat = () => {
  const dispatch = useDispatch();
  const query = useQuery();
  const { socket, data_date } = useSelector((state) => state);
  const notificationType = useSelector((state) => state.notificationType);
  const [openFile, setOpenFile] = useState(false);
  const [openToken, setOpenToken] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [tableData, setTableData] = useState({
    result_list: [],
    result_json: {},
    total_list: {},
    total_size: 0,
    validtion_info: {
      validated: true,
      error_message: [],
    },
  });

  const openFileModal = () => {
    // Remove any existing listeners to prevent duplicates
    socket.removeAllListeners('request_out');

    // Set up a new listener that will update the token
    socket.on('request_out', (data) => {
      if (data.status === '0') {
        const newToken = data?.content?.result_json?.noat_token || '';
        console.log('🚀 ~ socket.on ~ newToken:', newToken);

        // Clear previous token and set the new one
        // localStorage.removeItem('noat_token');
        localStorage.setItem('noat_token', newToken);

        console.log('Token updated:', newToken);

        // Only open the modal after successfully receiving the token
        setOpenFile(true);
      }
    });

    // Send the request to get a fresh token
    socket.emit('request_in', {
      channel: 'ss013_03_view',
      content: {
        action_type: 'get_noat_token',
      },
    });
  };

  const select_data = async () => {
    if (!socket) return;

    socket.removeAllListeners('request_out');

    dispatch(start_loading({}));

    const handleResponse = (data) => {
      console.log('Socket Response:', data); // Add this for debugging

      if (data.status === '0') {
        // Make sure we're setting the correct data
        if (data?.content?.result_list?.length >= 0) {
          setTableData(data.content);
        }
      } else {
        newAlert({ type: 'error', msg: 'Системд алдаа гарлаа' });
      }
      dispatch(end_loading({}));
      setIsLoading(false);
    };

    socket.on('request_out', handleResponse);

    const requestData = {
      channel: 'ss013_03_view',
      content: {
        action_type: 'noat_jobs_page',
        page: 1,
        size: 25,
        search: {},
      },
    };

    console.log('Emitting request:', requestData); // Add this for debugging
    socket.emit('request_in', requestData);
  };

  // useEffect(() => {
  //   select_data();
  // }, []);

  useEffect(() => {
    select_data();
    return () => {
      if (socket) {
        socket.removeAllListeners('request_out');
      }
    };
  }, [data_date, query, socket]);

  useEffect(() => {
    if (notificationType === 'НӨАТ') {
      select_data();
      dispatch(set_notification_type(''));
    }
  }, [notificationType]);

  const onCancel = () => {
    setOpenFile(false);
    select_data();
  };

  const onCancelToken = () => {
    setOpenToken(false);
  };

  const TableTitle = () => (
    <div style={{ marginBottom: '16px' }}>
      <CanView allowedRole="100_1">
        <Button
          className="confirm-btn ml-5"
          type="primary"
          size="small"
          onClick={() => openFileModal()}
          style={{ marginRight: '8px' }}
        >
          Өгөгдөл оруулах
        </Button>
      </CanView>
      <CanView allowedRole="100_1">
        <Button
          className="confirm-btn ml-5"
          type="primary"
          size="small"
          onClick={() => setOpenToken(true)}
        >
          Токен үүсгэх
        </Button>
      </CanView>
    </div>
  );

  const MainTable = () => (
    <div
      style={{
        width: '100%',
        height: 'calc(100vh - 220px)',
        backgroundColor: 'white',
        borderRadius: '8px',
        boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
        overflow: 'hidden',
      }}
    >
      <div style={{ padding: '16px' }}>
        <TableTitle />
        <div
          style={{
            border: '1px solid #e5e7eb',
            borderRadius: '8px',
            overflow: 'hidden',
          }}
        >
          <div style={{ overflowX: 'auto' }}>
            <table
              style={{
                width: '100%',
                fontSize: '14px',
                borderCollapse: 'collapse',
              }}
            >
              <thead>
                <tr
                  style={{
                    backgroundColor: '#f9fafb',
                    borderBottom: '1px solid #e5e7eb',
                  }}
                >
                  <th style={{ ...thStyle, width: '110px' }}>Огноо</th>
                  <th style={{ ...thStyle, width: '50px' }}>Жил</th>
                  <th style={{ ...thStyle, width: '50px' }}>Сар</th>
                  <th style={{ ...thStyle, width: '75px' }}>Төлөв</th>
                  <th style={{ ...thStyle, width: '100px' }}>Эх сурвалж</th>
                  <th style={{ ...thStyle }} colSpan={2}>
                    Борлуулалт
                  </th>
                  <th style={{ ...thStyle }}>Худалдан авалт</th>
                </tr>
                <tr
                  style={{
                    backgroundColor: '#f9fafb',
                    borderBottom: '1px solid #e5e7eb',
                  }}
                >
                  <th style={{ padding: '8px 16px' }} colSpan={5} />
                  <th style={{ ...thStyle, width: '150px' }}>Файлын нэр</th>
                  <th style={{ ...thStyle, width: '150px' }}>Файлын нэр</th>
                </tr>
              </thead>
              <tbody>
                {tableData.result_list.map((row, index) => (
                  <tr
                    key={index}
                    style={{
                      borderBottom: '1px solid #e5e7eb',
                      transition: 'background-color 0.15s',
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.backgroundColor = '#f9fafb')
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.backgroundColor = 'transparent')
                    }
                  >
                    <td style={{ ...tdStyle }}>{row.ognoo}</td>
                    <td style={{ ...tdStyle }}>{row.year}</td>
                    <td style={{ ...tdStyle }}>
                      {Array.isArray(row.month)
                        ? `${row.month.join(', ')} сар`
                        : `${row.month} сар`}
                    </td>
                    <td style={{ ...tdStyle }}>
                      <span
                        style={{
                          padding: '4px 8px',
                          fontSize: '12px',
                          fontWeight: '500',
                          borderRadius: '9999px',
                          ...getStatusStyle(row.state),
                        }}
                      >
                        {stateList[row.state] || ''}
                      </span>
                    </td>
                    <td style={{ ...tdStyle }}>
                      {typeList[row.bo_file_type] || ''}
                    </td>
                    <td
                      style={{
                        ...tdStyle,
                        color: '#2563eb',
                        cursor: 'pointer',
                      }}
                    >
                      {row.bo_file_name}
                    </td>
                    <td
                      style={{
                        ...tdStyle,
                        color: '#2563eb',
                        cursor: 'pointer',
                      }}
                    >
                      {row.ha_file_name}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <TokenView visible={openToken} onCancel={onCancelToken} />
      <FileUpload visible={openFile} onCancel={onCancel} />
      <MainTable />
    </>
  );
};

export default Noat;
